import { ProfessionTypeEnum } from '~/models';

export const EXCLUDED_PROFESSIONS = [ProfessionTypeEnum.DN];
